import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import Button from "../Button";
import { useTranslation } from "react-i18next";
import { useAuthStore } from "../../Stores/authStore";
import { useComponentsStore } from "../../Stores/componentsStore";

export function CookiePopup() {
  const [cookieState, setCookieState, setCookieModalVisible, cookieModalVisible] = useComponentsStore((state) => [
    state.cookieState,
    state.setCookieState,
    state.setCookieModalVisible,
    state.cookieModalVisible,
  ]);

  React.useEffect(() => {
    if (!useAuthStore.getState().firstTime) {
      if (cookieState.userHasInteracted === 0) {
        setTimeout(() => {
          setCookieModalVisible(true);
        }, 4000);
      } else {
        if (cookieState.cookiesEnabled) {
          window["ga-disable-G-HD1WNFNYCE"] = false;
        } else {
          window["ga-disable-G-HD1WNFNYCE"] = true;
        }
      }
    }

    return () => {};
  }, [cookieState]);

  const { t } = useTranslation();
  return (
    <Modal
      isOpen={cookieModalVisible}
      role="dialog"
      autoFocus={true}
      centered={true}
      className=""
      tabIndex="-1"
      zIndex="11"
      backdrop={true}
      toggle={() => {
        setCookieModalVisible(!cookieModalVisible);
      }}
    >
      <div className="modal-content">
        <ModalHeader
          tag="h1"
          className="ta-modals-header"
          toggle={() => {
            setCookieModalVisible(!cookieModalVisible);
          }}
        >
          {t("Cookie Options")}
        </ModalHeader>
        <ModalBody>
          <div className="th-grey-text">
            {t(
              "We only keep cookies essential to the site's functionality. To improve our service, we collect some basic (anonymous) analytics, which you may disable here."
            )}
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            className="tc-full-width-small"
            type="button"
            color="primary"
            onClick={() => {
              setCookieModalVisible(false);
              const cookieState = { userHasInteracted: 1, cookiesEnabled: true };
              setCookieState(cookieState);
            }}
          >
            {t("Keep Analytics")}
          </Button>
          <Button
            className="tc-full-width-small"
            type="button"
            color="secondary"
            onClick={() => {
              setCookieModalVisible(false);
              const cookieState = { userHasInteracted: 1, cookiesEnabled: false };
              setCookieState(cookieState);
            }}
          >
            {t("Disable Analytics")}
          </Button>
        </ModalFooter>
      </div>
    </Modal>
  );
}
